// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-tsx": () => import("/tmp/77f6d444/src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

